<template>
  <div class="invite-user-container">
    <invalid-token-card
      v-if="inviteTokenState === 'invalidToken'"
    />
    <invite-new-user-card
      v-else-if="inviteTokenState === 'invitedNewAccount'"
      :organizationName="inviteUser.organizationName"
      :httpRequesting="httpRequesting"
      :rejected="rejectedInvitation"
      :registered="registeredUser"
      @onSubmitNewUser="onSubmitNewUser"
      @onClickRejectInvitation="onClickRejectInvitation"
    />
    <required-sign-in-or-out-card
      v-else-if="inviteTokenState === 'signedInAnotherUser'"
      requiredAction="signOutAndSignInAgain"
      :email="inviteUser.email"
      @onClickSignOut="onClickSignOut"
    />
    <invite-signed-in-user-card
      v-else-if="inviteTokenState === 'signedInInvitedUser'"
      :organizationName="inviteUser.organizationName"
      :httpRequesting="httpRequesting"
      :rejected="rejectedInvitation"
      :approved="approvedInvitation"
      @onClickApproveInvitation="onClickApproveInvitation"
      @onClickRejectInvitation="onClickRejectInvitation"
    />
    <required-sign-in-or-out-card
      v-else-if="inviteTokenState === 'signInRequiredInvitedUser'"
      requiredAction="signIn"
      :email="inviteUser.email"
      @onClickSignIn="onClickSignIn"
    />
    <required-sign-in-or-out-card
      v-else-if="inviteTokenState === 'signOutRequiredCurrentUser'"
      requiredAction="signOut"
      :email="inviteUser.email"
      @onClickSignOut="onClickSignOut"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import store from '@/store'
import InvalidTokenCard from '@/components/molecules/inviteUser/InvalidTokenCard'
import InviteNewUserCard from '@/components/molecules/inviteUser/InviteNewUserCard'
import InviteSignedInUserCard from '@/components/molecules/inviteUser/InviteSignedInUserCard'
import RequiredSignInOrOutCard from '@/components/molecules/inviteUser/RequiredSignInOrOutCard'

export default {
  name: 'InviteUser',
  components: {
    InvalidTokenCard,
    InviteNewUserCard,
    InviteSignedInUserCard,
    RequiredSignInOrOutCard
  },
  data() {
    return {
      inviteTokenState: null,
      rejectedInvitation: false,
      approvedInvitation: false,
      registeredUser: false
    }
  },
  computed: {
    inviteToken: function() { return this.$route.query.invite_token },
    ...mapGetters({
      httpError: 'httpError',
      httpRequesting: 'httpRequesting',
      inviteUser: 'inviteAuth/inviteUser',
      signedInUser: 'auth/signedInUser'
    })
  },
  methods: {
    onClickSignIn: function() {
      this.$router.push({ name: 'signIn', query: { redirect:this.$route.fullPath }  })
    },
    async onClickSignOut() {
      if (this.inviteTokenState === 'signedInAnotherUser') {
        await this.signOut(true)
        this.$router.push({ name: 'signIn', query: { redirect:this.$route.fullPath }  })
      } else if (this.inviteTokenState === 'signOutRequiredCurrentUser') {
        await this.signOut(true)
        location.reload()
      }
    },
    async onSubmitNewUser(newUser) {
      newUser.email = this.inviteUser.email
      newUser.inviteToken = this.inviteToken

      await this.signUp(newUser)

      if (!this.httpError) {
        this.registeredUser = true
      }
    },
    async onClickApproveInvitation() {
      await this.apiPostUserOrganization({
        organizationId: this.inviteUser.organizationId,
        inviteToken: this.inviteToken
      })

      if (!this.httpError) {
        this.approvedInvitation = true
      }
    },
    async onClickRejectInvitation() {
      await this.rejectInviteUser(this.inviteToken)

      if (!this.httpError) {
        this.rejectedInvitation = true
      }
    },
    ...mapActions({
      signOut: 'auth/signOut',
      signUp: 'auth/signUp',
      validateInviteToken: 'inviteAuth/validateInviteToken',
      rejectInviteUser: 'inviteAuth/reject',
      apiPostUserOrganization: 'userOrganization/create'
    })
  },
  async created() {
    await this.validateInviteToken(this.inviteToken)
    if (this.inviteUser) {
      let decide

      if (this.inviteUser.userId) {
        // 既存アカウントを招待
        decide = () => {
          if (!this.signedInUser?.id) {
            // ログインを要求
            this.inviteTokenState = 'signInRequiredInvitedUser'
          } else if (this.inviteUser.userId != this.signedInUser?.id) {
            // ログアウト -> ログインを要求
            this.inviteTokenState = 'signedInAnotherUser'
          } else {
            // 招待カード表示
            this.inviteTokenState = 'signedInInvitedUser'
          }
        }
      } else {
        // 新規アカウントを招待
        decide = () => {
          if (this.signedInUser?.id) {
            // ログアウトを要求
            this.inviteTokenState = 'signOutRequiredCurrentUser'
          } else {
            // 新規登録カード表示
            this.inviteTokenState = 'invitedNewAccount'
          }
        }
      }
      if (store.getters['auth/initialized']) {
        decide()
      } else {
        const unwatch = store.watch((state, getters) => getters['auth/initialized'], () => {
          unwatch()
          decide()
        })
      }
    } else {
      this.inviteTokenState = 'invalidToken'
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/mediaquery";
@import "@/styles/variables";

.invite-user-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
